import { colors } from '@/constants';
import styled, { css } from 'styled-components';

export const PackagingRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 50px;
  margin-bottom: 15px;
  padding: 0 8px;
`;

export const TableBody = styled.div`
  background-color: ${colors.gray.gray0};
  overflow: hidden;
  border-radius: 10px;
`;

export const TableRow = styled.div<{ $applyBackground?: boolean }>`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  ${(props) => props.$applyBackground && css`
      background-color: ${colors.gray.gray10};
  ` };
`;

export const TableCell = styled.div<{ $left?: boolean; $bgColor?: string; }>`
  font-family: Roboto, sans-serif;
  font-size: 14px;
  padding: 16px 20px;
  color: ${colors.brand.grafite};
  text-align: ${props => props.$left ? 'left' : 'right'};
  background-color: ${props => props.$bgColor ?? colors.background1};
`;